import React, { useContext } from "react";
import MedicationOutlinedIcon from "@mui/icons-material/MedicationOutlined";

import { ConfiguracionContext } from "../../../../context/ConfiguracionContext";
import MaestroArchivo from "../../common/MaestroArchivo";

const columns = [
  { field: "id", header: "ID", width: "8rem" },
  { field: "sku", header: "SKU", width: "12rem" },
  { field: "nombre", header: "Descripción" },
  { field: "habilitado", header: "Habilitado", type: "bool", width: "10rem" },
];

const fields = [
  { name: "sku", label: "SKU", type: "text", required: true, md: 4 },
  {
    name: "nombre",
    label: "Descripción",
    type: "text",
    required: true,
    requiredMsg: "La descripción es necesaria !.",
    md: 8,
  },
  { name: "habilitado", label: "Habilitado", type: "switch" },
];

export default function Medicamentos() {
  const {
    medicamentos,
    obtenerMedicamentos,
    agregarMedicamento,
    actualizarMedicamento,
  } = useContext(ConfiguracionContext);

  return (
    <MaestroArchivo
      titulo="Medicamentos"
      entidad="medicamento"
      layout="Medicamentos"
      icono={<MedicationOutlinedIcon />}
      items={medicamentos}
      columns={columns}
      fields={fields}
      nuevoDefault={{ sku: "", nombre: "", habilitado: true }}
      onObtener={() => obtenerMedicamentos({ todos: true })}
      onAgregar={(data) => agregarMedicamento({ medicamento: data })}
      onActualizar={(data) => actualizarMedicamento({ medicamento: data })}
    />
  );
}
